import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faSortAmountUp,
  faSortAmountDown,
} from '@fortawesome/free-solid-svg-icons';
import { Input } from '@v2/components/Input';
import { Select } from '@v2/components/Select';
import { TableFiltersProps, SortOption } from './types';
import { styles } from './styles';

export function TableFilters<T>({
  search,
  onSearchChange,
  searchPlaceholder = 'Search...',
  sortOptions = [],
  sortConfig,
  onSortChange,
  onToggleSortDirection,
  onClearSort,
  className,
}: TableFiltersProps<T>) {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };

  const handleSortKeyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const key = e.target.value;
    if (key === '') {
      onClearSort();
    } else {
      onSortChange(key as keyof T);
    }
  };

  const selectOptions = [
    { value: '', label: 'Sort by' },
    ...sortOptions.map((opt) => ({ value: opt.key, label: opt.label })),
  ];

  return (
    <div className={clsx(styles.container, className)}>
      <div style={{ maxWidth: 300, flex: 1 }}>
        <Input
          type="text"
          value={search}
          onChange={handleSearchChange}
          placeholder={searchPlaceholder}
          icon={<FontAwesomeIcon icon={faSearch} className="tw-text-neutral-400" />}
        />
      </div>

      {sortOptions.length > 0 && (
        <div className={styles.sortContainer}>
          <div className={styles.sortSelect}>
            <Select
              options={selectOptions}
              value={sortConfig ? String(sortConfig.key) : ''}
              onChange={handleSortKeyChange}
            />
          </div>
          <button
            type="button"
            onClick={onToggleSortDirection}
            disabled={!sortConfig}
            className={clsx(
              styles.directionButton,
              sortConfig && styles.directionButtonActive
            )}
            aria-label={`Sort ${sortConfig?.direction === 'asc' ? 'ascending' : 'descending'}`}
          >
            <FontAwesomeIcon
              icon={sortConfig?.direction === 'desc' ? faSortAmountDown : faSortAmountUp}
            />
          </button>
        </div>
      )}
    </div>
  );
}

export type { TableFiltersProps, SortOption } from './types';
export default TableFilters;
